import gql from 'graphql-tag'
import { Stock } from '@/entities/sales'
import { QueryBuilder } from '../utils'
import {
  BaseStockFragment,
  KeyIdentifierFragment,
  PriceFragment,
  StockViewDetailFragment,
} from '@/graphql/fragments/sales'
import {
  BaseAttributeFragment,
  BaseComponentFragment,
  BaseComponentValueFragment, BaseVersionYearFragment, VersionFragment,
  YearFragment,
} from '@/graphql/fragments/vehicle'
import { ProcessStatusFragment } from '@/graphql/fragments/settings'
import { BaseDealFragment, BaseLeadFragment, DealFragment, PipelineFragment } from '@/graphql/fragments/crm'
import { AppraisalFragment } from '@/graphql/fragments/purchase'
import { AutoFragment } from '@/graphql/fragments/public'

const query = gql`
  ${BaseStockFragment}
  ${VersionFragment}
  ${BaseVersionYearFragment}
  ${BaseAttributeFragment}
  ${BaseComponentFragment}
  ${BaseComponentValueFragment}
  ${YearFragment}
  ${PriceFragment}
  ${ProcessStatusFragment}
  ${KeyIdentifierFragment}
  ${DealFragment}
  ${BaseLeadFragment}
  ${PipelineFragment}
  ${AppraisalFragment}
  ${BaseDealFragment}
  ${StockViewDetailFragment}
  ${AutoFragment}
  query stock($filter: sales_stock_bool_exp, $order: [sales_stock_order_by!], $limit: Int, $offset: Int) {
    records: sales_stock(order_by: $order, limit: $limit, offset: $offset, where: $filter) {
      ...StockBase
      viewDetails: stock_detail {
        ...StockViewDetail
        auto{
          ...Auto
          generation {
            id
            registration:automotive_registrations{
              permission
            }
            attributes(where: {component: {id: {_lte: 4}}}) {
              component {
                id
                slug
              }
              componentValue: component_value {
                id
                value
              }
              value
            }
          }
        }
        attributes {
          component {
            id
            slug
          }
          componentValue: component_value {
            id
            value
          }
          value
        }
      }
      prices(order_by: {id: desc}, limit: 2) {
        ...Price
      }
      deals{
        ...DealBase
        closingReason: closing_reason {
          ...ClosingReason
        }
        status {
          ...ProcessStatus
        }
        lead {
          ...LeadBase
        }
      }
      status {
        ...ProcessStatus
      }
      keyIdentifier: key_identifier{
        ...KeyIdentifier
      }
    }
    total: sales_stock_aggregate(where: $filter) {
      aggregate {
        count(distinct: true)
      }
    }
  }
`

export const stock = QueryBuilder(query, Stock)
export default stock
